<template>
  <div>
	<loading :active.sync="isLoading" color="#64B9B0"></loading>
	<div class="content-wrapper">
	  <div class="container-fluid">
		<!-- Breadcrumbs-->
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
				<router-link to="/adm/titulares">Titulares</router-link>
				</li>
				<li class="breadcrumb-item active">Detalhes Titular</li>
			</ol>

			<div class="box_general padding_bottom">
				<div class="header_box version_2">
				<h2>
					<i class="fa fa-info-circle"></i>Informações do Titular
				</h2>
			</div>
					
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Nome do Titular</label>
							<input
								type="text"
								class="form-control"
								v-model="novo_titular.name"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
						<label>CPF do Titular</label>
						<input
							type="text"
							class="form-control"
							v-mask="['###.###.###-##']"
							v-model="novo_titular.cpf"
						/>
						</div>
					</div>
						
					<div class="col-md-4">
						<div class="form-group">
						<label>E-mail do Titular</label>
						<input
							type="text"
							class="form-control"
							v-model="novo_titular.email"
						/>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Nome da Mae</label>
							<input
							type="text"
							class="form-control"
							v-model="novo_titular.nome_mae"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Nome do Pai</label>
							<input
							type="text"
							class="form-control"
							v-model="novo_titular.nome_pai"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Subscriber</label>
							<v-select 
								:options="subscribers" 
								:reduce="subscriber => subscriber.id"
								v-model="novo_titular.subscribers_id" 
								label="valor" />
							<!-- <select
							v-model="novo_titular.subscribers_id"
							class="form-control"
							>
								<option
									v-for="(subscriber,index) in subscribers"
									:key="index"
									:value="subscriber.id"
								>{{subscriber.id}}</option>
			  			</select> -->
						</div>
					</div>

				</div>

				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Data de Nascimento</label>
							<date-picker
								v-model="novo_titular.birth_date"
								:lang="lang"
								format="DD/MM/YYYY"
								value-type="format"
								></date-picker>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>CNS</label>
							<input
							type="text"
							class="form-control"
							v-model="novo_titular.cns"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Parentesco</label>
							<input
							type="text"
							class="form-control"
							v-model="novo_titular.parentesco"
							/>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<p class="pull-right">
							<button class="btn_1 medium" @click="cria_titular()">Criar Titular</button>
						</p>
					</div>
				</div>

			</div>
		</div>
	</div>
</div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import { toTimeStamp } from "@/utils/formater";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'

export default {
  mixins: [funcoesGerais],
  data() {
		return {
			lang: {
			days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
			months: [
			"Jan",
			"Fev",
			"Mar",
			"Abr",
			"Mai",
			"Jun",
			"Jul",
			"Ago",
			"Set",
			"Out",
			"Nov",
			"Dec"
			],
			pickers: [
			"prox 7 dias",
			"prox 30 dias",
			"7 dias anteriores",
			"30 dias anteriores"
			],
			placeholder: {
				date: "Selecione a data",
				dateRange: "Selecione o intervalo"
			}
			},
			novo_titular: {},
			subscribers: [],
			isLoading: false,
		};
	},

	created() {
		let self = this;
		self.isLoading = true;

		ajax("get", "usuarios").then(res => {
			self.isLoading = false;
			let subscribersRes = res.data;
			for(let sub of subscribersRes) {
				if(sub.subscriber) {
					sub.subscriber.valor = `${sub.name} - ${sub.subscriber.id}`;
					self.subscribers.push(sub.subscriber);
				}
			}

		}).catch(e => {
			self.isLoading = false;
			tratamento_requisicao(e);
		}) 
	},
	
  methods: {
		cria_titular() {
			let self = this;
			self.isLoading = true;
			self.novo_titular.birth_date = toTimeStamp(self.novo_titular.birth_date);
			ajax("post", "titulares", self.novo_titular).then(res => {
				self.isLoading = false;
				alerta("success", "Sucesso", "Titular criado com sucesso");
				self.$router.replace(
			self.$route.query.redirect || "/adm/titulares"
		);
			}).catch(err => {
				self.isLoading = false;
				tratamento_requisicao(err);
			})
		}
  }
}
</script>
